import React, {Component} from "react";
import {ClipLoader} from 'react-spinners';

import Flexbox from 'flexbox-react';
import '../../stylesheets/shop_list.css';
import {TAPINGO, GRUBHUB, SEAMLESS, LOCALSTORAGE_BRAND_ID_KEY} from '../../constants';
import grubhubLogo from "../../assets/GH_Logotype_Rebrand_Orange_RGB.svg";


const mainLogoWrapper = {
  margin: "auto auto 0 auto",
  width: "30%"
};

const loadingText = {
  fontFamily: "GraphikLight",
  fontSize: "7.5vh",
  marginTop: "6vh",
};

const clipLoaderContainer = {
  marginTop: "6vh"
};

const mainLogoStyle = {
  width: "100%"
};

const loadingPageColors = {
  [TAPINGO]: {
    backgroundColor: "rgb(227, 89, 16)",
    secondaryColor: "rgb(255,255,255)"
  },
  [SEAMLESS]: {
    backgroundColor: "rgb(14, 138, 144)",
    secondaryColor: "rgb(255,255,255)"
  },
  [GRUBHUB]: {
    backgroundColor: "rgb(228, 228, 228)",
    secondaryColor: "rgb(255, 128, 0)",
    secondaryColor2: "rgb(255, 85, 0)"
  },
};

export default class LoadingPage extends Component {
  render() {
    const brandId = parseInt(localStorage.getItem(LOCALSTORAGE_BRAND_ID_KEY), 10) || GRUBHUB;
    const loadingPageColor = loadingPageColors[brandId];

    return (
      <Flexbox width="100.1vw" height="100.1vh" style={loadingPageColor}>
        <Flexbox width="100%" height="100%" flexGrow={1} flexDirection="column">
          <Flexbox width="100%" height="35%" flexGrow={1} flexDirection="row">
            <div style={mainLogoWrapper}>
              <img src={grubhubLogo} style={mainLogoStyle} alt="loadingLogo"/>
            </div>
          </Flexbox>
          <Flexbox flexDirection="column" justifyContent="center" alignItems="center">
            <div style={clipLoaderContainer}>
              <ClipLoader
                sizeUnit={"px"}
                size={50}
                color={loadingPageColor.secondaryColor2 || loadingPageColor.secondaryColor}
                loading={true}
              />
            </div>
            <div style={{...loadingText, color: loadingPageColor.secondaryColor2 || loadingPageColor.secondaryColor}}>
              Loading...
            </div>
          </Flexbox>
          <Flexbox width="100%" height="42%" flexGrow={1} flexDirection="row" justifyContent="center"></Flexbox>
        </Flexbox>
      </Flexbox>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/loading_page/loading_page.jsx